import { UPLOAD_TIMEOUT_MS } from '~/lib/axios';
import { csrfHeaders } from '~/lib/csrf';

/**
 * The request settings every file upload needs: the CSRF header, no JSON content type so axios
 * sends the form as multipart, and the longer upload timeout.
 *
 * @example apiClient({ method: 'post', url, ...multipartRequest(form) })
 */
export function multipartRequest(payload: FormData) {
  return {
    headers: { ...csrfHeaders(), 'Content-Type': undefined },
    timeout: UPLOAD_TIMEOUT_MS,
    data: payload,
  };
}
